import { response } from './response';
import { sleep } from './sleep';
import { createMedicalInstitutionsMock } from '../medicalInstitutions';
import { MockApi } from './types';
import type { createMedicalInstitutionsApi } from '@/src/api/medicalInstitutions';

export default {
  async getMedicalInstitutions() {
    await sleep();
    return new Promise((resolve) => {
      return resolve(response(createMedicalInstitutionsMock()));
    });
  },
} as MockApi<ReturnType<typeof createMedicalInstitutionsApi>>;
